export default __webpack_public_path__ + "static/media/icon-FreeShipping.02a584e4.svg";